// Prefer the server-generated WebP (always browser-safe, incl. converted HEIC),
// falling back to the original file. Use with onImgError below.
export function bestImg(m) {
  if (!m) return null;
  return m.webp_url || m.url || m.thumb_url || null;
}

// onError handler: if the WebP fails, try the original url once, then give up.
export function onImgError(m) {
  return (e) => {
    const el = e.currentTarget;
    if (m && m.url && !el.dataset.fb && el.src !== m.url) {
      el.dataset.fb = "1";
      el.src = m.url;
    } else {
      el.style.visibility = "hidden";
    }
  };
}
